module.exports = __webpack_public_path__ + "static/launchpad-37fc394576ff36e1bd9bc1b05a9285d9.png";